import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgExpert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71 61" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#979797"
      transform="translate(0 -12)"
    >
      <path d="m14.547 44.001 42.83-.614L69.246 35.5 35.5 13.074 1.755 35.5l12.792 8.501zM6 38.943V50.41M3.347 56C-.348 62.988.32 68.322 5.35 72c5.201-3.669 6.04-9.002 2.513-16" />
      <ellipse cx={36.5} cy={51} rx={21.5} ry={7} />
      <path d="M58 52v-9.808C58 38.22 48.374 35 36.5 35S15 38.22 15 42.192v9.77" />
      <rect width={5} height={8} x={3.5} y={50.5} rx={2.5} />
    </g>
  </svg>
);
const Memo = memo(SvgExpert);
export default Memo;
